<template>
  <div class="mt-5">
    <!-- Principal -->
    <v-list-item>
      <v-autocomplete outlined dense :loading="principalLoading" @keyup="searchPrincipalAction"
        :search-input.sync="searchPrincipal" :items="principals" hide-no-data class="pa-0" label="Principal's signature"
        v-model="principal" style="width: 100%" />
    </v-list-item>

    <!-- Exam Coordinator (Global) -->
    <v-list-item>
      <v-autocomplete outlined dense :search-input.sync="searchExamCoordinator" :items="coordinators"
        @keyup="searchExamCoordinatorAction" hide-no-data label="Exam Coordinator's Signature (GLOBAL)"
        :loading="coordinatorLoading" class="pa-0" v-model="exam_coordinator" style="width: 100%" />
    </v-list-item>

    <!-- Secondary Exam Coordinator -->
    <v-list-item>
      <v-autocomplete outlined dense :search-input.sync="searchSecondaryExamCoordinator"
        :items="secondaryExamCoordinators" @keyup="searchSecondaryExamCoordinatorAction" hide-no-data
        label="Secondary Exam Coordinator's Signature" :loading="secondaryExamCoordinatorLoading" class="pa-0"
        v-model="secondary_exam_coordinator" style="width: 100%" />
    </v-list-item>

    <!-- Higher Secondary Exam Coordinator -->
    <v-list-item>
      <v-autocomplete outlined dense :search-input.sync="searchHigherSecondaryExamCoordinator"
        :items="higherSecondaryExamCoordinators" @keyup="searchHigherSecondaryExamCoordinatorAction" hide-no-data
        label="Higher Secondary Exam Coordinator's Signature" :loading="higherSecondaryExamCoordinatorLoading"
        class="pa-0" v-model="higher_secondary_exam_coordinator" style="width: 100%" />
    </v-list-item>

    <!-- Superintendent -->
    <v-list-item>
      <v-autocomplete outlined dense :search-input.sync="searchSuperintendent" :items="superintendents"
        @keyup="searchSuperintendentAction" hide-no-data :loading="superintendentLoading" class="pa-0"
        label="Superintendent's Signature" v-model="superintendent" style="width: 100%" />
      <v-icon v-if="superintendent" style="color: red; cursor: pointer; vertical-align: super"
        @click="SRemoveDialog = true">
        close
      </v-icon>
    </v-list-item>

    <!-- Accountant -->
    <v-list-item>
      <v-autocomplete :search-input.sync="searchAccountant" :items="accountants" outlined dense
        @keyup="searchAccountantAction" hide-no-data label="Accountant's Signature" :loading="accountantLoading"
        class="pa-0" v-model="accountant" style="width: 100%" />
      <v-icon v-if="accountant" style="color: red; cursor: pointer; vertical-align: super"
        @click="ARemoveDialog = true">
        close
      </v-icon>
    </v-list-item>

    <!-- Checkboxes -->
    <v-list-item>
      <v-checkbox style="margin-right: 20px" color="blue" v-model="allow_back_date_attendance">
        <template v-slot:label>
          <div style="color: #333">
            Allow Back Date Attendance
            <p style="line-height: 10px">
              <small style="color: #777; font-size: 12px; font-weight: normal">
                Class teacher, administrators will be able to take attendance for previous dates.
              </small>
            </p>
          </div>
        </template>
      </v-checkbox>
    </v-list-item>

    <v-list-item>
      <v-checkbox style="margin-right: 20px" color="blue" v-model="enable_qr_log_sms">
        <template v-slot:label>
          <div style="color: #333">
            Enable SMS For QR Log
            <p style="line-height: 10px">
              <small style="color: #777; font-size: 12px; font-weight: normal">
                Enable if you want to receive SMS for QR Log
              </small>
            </p>
          </div>
        </template>
      </v-checkbox>
    </v-list-item>

    <v-list-item>
      <v-checkbox style="margin-right: 20px" color="blue" v-model="enable_attendance_by_qr">
        <template v-slot:label>
          <div style="color: #333">
            Enable Attendance by QR
            <p style="line-height: 10px">
              <small style="color: #777; font-size: 12px; font-weight: normal">
                Enable if you want to take attendance by scanning a QR code.
              </small>
            </p>
          </div>
        </template>
      </v-checkbox>
    </v-list-item>

    <!-- Save Button -->
    <v-list-item style="margin-top: 34px;">
      <v-btn block large color="info outlined" @click="academicSubmit">Save</v-btn>
    </v-list-item>

    <!-- Superintendent Remove Dialog -->
    <v-dialog v-model="SRemoveDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="title pa-3 red white--text">
          <v-icon class="mr-2 white--text">warning</v-icon>
          Please, wait!
        </v-card-title>
        <v-card-text class="ma-0">Are you sure you want to remove Superintendent Signature?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" outlined small @click="SRemoveDialog = false">No</v-btn>
          <v-btn color="error" outlined small @click="removeSuperintendent">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Accountant Remove Dialog -->
    <v-dialog v-model="ARemoveDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="title pa-3 red white--text">
          <v-icon class="mr-2 white--text">warning</v-icon>
          Please, wait!
        </v-card-title>
        <v-card-text class="ma-0">Are you sure you want to remove Accountant Signature?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" outlined small @click="ARemoveDialog = false">No</v-btn>
          <v-btn color="error" outlined small @click="removeAccountant">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState( [ "batch" ] ),
  },
  data: () => ( {
    searchPrincipal: null,
    principal: "",
    principalLoading: false,
    principals: [],

    superintendentLoading: false,
    superintendents: [],
    searchSuperintendent: null,
    superintendent: "",

    accountantLoading: false,
    accountants: [],
    searchAccountant: null,
    accountant: "",

    coordinatorLoading: false,
    coordinators: [],
    searchExamCoordinator: null,
    exam_coordinator: "",

    secondaryExamCoordinators: [],
    secondary_exam_coordinator: "",
    secondaryExamCoordinatorLoading: false,
    searchSecondaryExamCoordinator: null,

    higherSecondaryExamCoordinators: [],
    higher_secondary_exam_coordinator: "",
    higherSecondaryExamCoordinatorLoading: false,
    searchHigherSecondaryExamCoordinator: null,

    SRemoveDialog: false,
    ARemoveDialog: false,
    allow_back_date_attendance: false,
    enable_qr_log_sms: false,
    enable_attendance_by_qr: false,
    is_hs_status: "",
  } ),
  mounted() {
    this.is_hs_status = JSON.parse( this.$storage.get( "batch" ) );
    this.getAcademicSetting();
  },
  methods: {
    getAcademicSetting() {
      this.principalLoading = true;
      this.coordinatorLoading = true;
      this.secondaryExamCoordinatorLoading = true;
      this.higherSecondaryExamCoordinatorLoading = true;
      this.superintendentLoading = true;
      this.accountantLoading = true;

      this.$rest
        .get( "/api/academic-setting?is_hs=" + this.is_hs_status.is_hs )
        .then( ( { data } ) => {
          console.log( data )
          this.allow_back_date_attendance = data.academic.academic.allowBackdateAttendance || false;
          this.enable_qr_log_sms = data.academic.academic.enableQrLogSms || false;
          this.enable_attendance_by_qr = data.academic.academic.enableAttendanceByQr || false;

          if ( data.signature.principal?.length ) {
            this.principals = [
              {
                value: this.is_hs_status.is_hs
                  ? data.academic.academic.college_signature.principal
                  : data.academic.academic.signature.principal,
                text: data.signature.principal,
              },
            ];
            this.principal = this.principals[ 0 ].value;
          }

          if ( data.signature.exam_coordinator?.length ) {
            this.coordinators = [
              {
                value: this.is_hs_status.is_hs
                  ? data.academic.academic.college_signature.exam_coordinator
                  : data.academic.academic.signature.exam_coordinator,
                text: data.signature.exam_coordinator,
              },
            ];
            this.exam_coordinator = this.coordinators[ 0 ].value;
          }

          if ( data.signature.secondary_exam_coordinator_name?.length ) {
            this.secondaryExamCoordinators = [
              {
                value: this.is_hs_status.is_hs
                  ? data.academic.academic.college_signature.secondary_exam_coordinator_name
                  : data.academic.academic.signature.secondary_exam_coordinator_name,
                text: data.signature.secondary_exam_coordinator_name,
              },
            ];
            this.secondary_exam_coordinator_name = this.secondaryExamCoordinators[ 0 ].value;
          }

          if ( data.signature.secondary_exam_coordinator_name?.length ) {
            this.secondaryExamCoordinators = [
              {
                value: this.is_hs_status.is_hs
                  ? data.academic.academic.college_signature.secondary_exam_coordinator
                  : data.academic.academic.signature.secondary_exam_coordinator,
                text: data.signature.secondary_exam_coordinator_name,
              },
            ];
            this.secondary_exam_coordinator = this.secondaryExamCoordinators[ 0 ].value;
          }
          if ( data.signature.higher_secondary_exam_coordinator_name?.length ) {
            this.higherSecondaryExamCoordinators = [
              {
                value: this.is_hs_status.is_hs
                  ? data.academic.academic.college_signature.higher_secondary_exam_coordinator
                  : data.academic.academic.signature.higher_secondary_exam_coordinator,
                text: data.signature.higher_secondary_exam_coordinator_name,
              },
            ];
            this.higher_secondary_exam_coordinator = this.higherSecondaryExamCoordinators[ 0 ].value;
          }


          if ( data.signature.superintendent?.length ) {
            this.superintendents = [
              {
                value: this.is_hs_status.is_hs
                  ? data.academic.academic.college_signature.superintendent
                  : data.academic.academic.signature.superintendent,
                text: data.signature.superintendent,
              },
            ];
            this.superintendent = this.superintendents[ 0 ].value;
          }

          if ( data.signature.accountant?.length ) {
            this.accountants = [
              {
                value: this.is_hs_status.is_hs
                  ? data.academic.academic.college_signature.accountant
                  : data.academic.academic.signature.accountant,
                text: data.signature.accountant,
              },
            ];
            this.accountant = this.accountants[ 0 ].value;
          }
        } )
        .finally( () => {
          this.principalLoading = false;
          this.coordinatorLoading = false;
          this.secondaryExamCoordinatorLoading = false;
          this.higherSecondaryExamCoordinatorLoading = false;
          this.superintendentLoading = false;
          this.accountantLoading = false;
        } );
    },

    academicSubmit() {
      this.$rest
        .put( "/api/setting", {
          allow_back_date_attendance: this.allow_back_date_attendance.toString(),
          enable_qr_log_sms: this.enable_qr_log_sms.toString(),
          enable_attendance_by_qr: this.enable_attendance_by_qr.toString(),
          flag: "academic",
          is_hs: this.is_hs_status.is_hs,
          principal: parseInt( this.principal ),
          exam_coordinator: this.exam_coordinator,
          secondary_exam_coordinator: this.secondary_exam_coordinator,
          higher_secondary_exam_coordinator: this.higher_secondary_exam_coordinator,
          superintendent: this.superintendent,
          accountant: this.accountant,

          principal_name: this.searchPrincipal,
          exam_coordinator_name: this.searchExamCoordinator,
          secondary_exam_coordinator_name: this.searchSecondaryExamCoordinator,
          // secondary_exam_coordinator_name: this.searchSecondaryExamCoordinator,
          accountant_name: this.searchAccountant,
          superintendent_name: this.searchSuperintendent,
          higher_secondary_exam_coordinator_name: this.searchHigherSecondaryExamCoordinator,
        } )
        .then( () => {
          this.$events.fire( "notification", {
            message: "Setting updated successfully",
            status: "success",
          } );
          this.getAcademicSetting();
        } )
        .catch( ( e ) => {
          this.$events.fire( "notification", {
            message: e.response.data.message,
            status: "error",
          } );
        } );
    },

    removeSuperintendent() {
      this.superintendent = "";
      this.academicSubmit();
      this.SRemoveDialog = false;
    },
    removeAccountant() {
      this.accountant = "";
      this.academicSubmit();
      this.ARemoveDialog = false;
    },

    searchPrincipalAction() {
      if ( !this.searchPrincipal ) return;
      this.principalLoading = true;
      this.$rest
        .get( "api/setting-teacher-list?name=" + this.searchPrincipal + "&role=principal" )
        .then( ( { data } ) => {
          this.principals = data.map( ( item ) => ( {
            value: item.id.toString(),
            text: item.name,
          } ) );
        } )
        .finally( () => {
          this.principalLoading = false;
        } );
    },

    searchExamCoordinatorAction() {
      if ( !this.searchExamCoordinator ) return;
      this.coordinatorLoading = true;
      this.$rest
        .get( "api/setting-teacher-list?name=" + this.searchExamCoordinator + "&role=exam-coordinator" )
        .then( ( { data } ) => {
          this.coordinators = data.map( ( item ) => ( {
            value: item.id.toString(),
            text: item.name,
          } ) );
        } )
        .finally( () => {
          this.coordinatorLoading = false;
        } );
    },

    searchSecondaryExamCoordinatorAction() {
      if ( !this.searchSecondaryExamCoordinator ) return;
      this.secondaryExamCoordinatorLoading = true;
      this.$rest
        .get( "api/setting-teacher-list?name=" + this.searchSecondaryExamCoordinator + "&role=exam-coordinator" )
        .then( ( { data } ) => {
          this.secondaryExamCoordinators = data.map( ( item ) => ( {
            value: item.id.toString(),
            text: item.name,
          } ) );
        } )
        .finally( () => {
          this.secondaryExamCoordinatorLoading = false;
        } );
    },
    searchHigherSecondaryExamCoordinatorAction() {
      if ( !this.searchHigherSecondaryExamCoordinator ) return;
      this.higherSecondaryExamCoordinatorLoading = true;
      this.$rest
        .get( "api/setting-teacher-list?name=" + this.searchHigherSecondaryExamCoordinator + "&role=exam-coordinator" )
        .then( ( { data } ) => {
          this.higherSecondaryExamCoordinators = data.map( ( item ) => ( {
            value: item.id.toString(),
            text: item.name,
          } ) );
        } )
        .finally( () => {
          this.higherSecondaryExamCoordinatorLoading = false;
        } );
    },

    searchSuperintendentAction() {
      if ( !this.searchSuperintendent ) return;
      this.superintendentLoading = true;
      this.$rest
        .get( "api/setting-teacher-list?name=" + this.searchSuperintendent + "&role=teacher" )
        .then( ( { data } ) => {
          this.superintendents = data.map( ( item ) => ( {
            value: item.id.toString(),
            text: item.name,
          } ) );
        } )
        .finally( () => {
          this.superintendentLoading = false;
        } );
    },

    searchAccountantAction() {
      if ( !this.searchAccountant ) return;
      this.accountantLoading = true;
      this.$rest
        .get( "api/setting-teacher-list?name=" + this.searchAccountant + "&role=accountant" )
        .then( ( { data } ) => {
          this.accountants = data.map( ( item ) => ( {
            value: item.id.toString(),
            text: item.name,
          } ) );
        } )
        .finally( () => {
          this.accountantLoading = false;
        } );
    },
  },
};
</script>
